import { AnalyticsBrowser } from '@segment/analytics-next'
import { serverEnvironment } from 'env'
import { generatePrefix } from 'utils/mixpanel'

type SegmentIdentifyType = {
  userId: number
  orgId: number
}

export const segmentAnalytics = AnalyticsBrowser.load({
  writeKey: import.meta.env.REACT_APP_SEGMENT_KEY,
})

export const segmentIdentify = ({ userId, orgId }: SegmentIdentifyType): void => {
  const userPrefix = generatePrefix(userId.toString())
  const orgPrefix = generatePrefix(orgId.toString())

  if (['aws', 'oci', 'staging', 'dev'].includes(serverEnvironment)) {
    segmentAnalytics.identify(
      userPrefix,
      {}, // to trigger traits
      {
        event: 'User Active',
      },
    )
    segmentAnalytics.group(
      orgPrefix,
      {}, // to trigger traits
      {
        event: 'Account Active',
      },
    )
  }
  // window.Vitally.nps('survey', {
  //   userId: userPrefix,
  //   accountId: orgPrefix,
  //   productName: 'Jisr HR',
  //   delay: 0,
  // })
}
